export default "__VITE_ASSET__BsmbH2Un__"